<template>
    <!--图片组-->
    <div class="image-container">

        <div v-for="(img, index) in mhshImgData" :key="index" class="image-item" @mouseenter="imgMouseEnter(index)"
            @mouseleave="imgMouseleave" @click="handleMhshClick(img.link)" :class="{
                active: currentHoverIndex === index,
                inactive: currentHoverIndex !== -1 && currentHoverIndex !== index
            }">
            <picture class="el-image">
                <!-- 优先加载 WebP 格式 -->
                <!-- <source :srcset="img.url" type="image/webp" /> -->
                <!-- 回退兼容 jpg 格式 -->
                <!-- <img :src="img['url-compatible']" alt="向下兼容图片" loading="lazy" decoding="async" /> -->
                <img :src="img['url-compatible']" alt="向下兼容图片"/>
            </picture>
            <div class="imgText">
                <p class="text-lg">{{ img.description }}</p>
                <div class="imgBtn" v-if="currentHoverIndex === index">
                    <button @click="handleMhshClick(img.link)">浏览地图</button>
                </div>
                <div class="imgDiv" v-else :style="{ 'background-color': img.color }"></div>
            </div>
        </div>
    </div>

</template>

<script setup>
//props
import { ref } from 'vue';
import source from "../components/source.js";
const mhshImgData = ref(source.mhshItems)

//declare
const currentHoverIndex = ref(-1);

//methods
const imgMouseEnter = (index) => {
    currentHoverIndex.value = index;
};
const imgMouseleave = () => {
    currentHoverIndex.value = -1;
};
const handleMhshClick = (link) => {
    if (link) {
        
        window.open(link, "_blank");
    }
}
</script>

<style scoped lang="scss">
.image-container {
    display: flex;
    column-gap: 0.46875vw;
    row-gap: 0.9259259259vh;
    height: 40.7407407407vh;
}

.image-item {
    flex: 1;
    border-radius: 0.7407407407vh 0.4166666667vw 0.7407407407vh 0.4166666667vw;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;

    .imgText {
        position: absolute;
        bottom: 2.7777777778vh;
        left: 1.0416666667vw;

        .text-lg {
            font-size: 18px;
            line-height: 1.75rem;
            font-weight: bold;
        }

        p {
            color: #ffffff;
            margin-bottom: 0.462962963vh;
        }
        .imgBtn{
            text-align: left;line-height: 14px;
        }

        .imgDiv {
            height: 0.462962963vh;
            width: 3.3333333333vw;
            border-radius: 0.462962963vh 0.2604166667vw 0.462962963vh 0.2604166667vw;
        }

        button {

            padding: 5px 8px;
            background: rgba(255, 255, 255, 0.9);
            color: #333;
            border: none;
            border-radius: 3px;
            font-size: 14px;
            cursor: pointer;
            z-index: 2;
        }
    }
}

.image-item .el-image {
    width: 100%;
    height: 100%;
    transition: transform 0.3s ease;
}

.image-item .el-image>img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

/* 悬停时放大当前图片，其他图片缩小 */
.image-item.active {
    flex-grow: 1;
}

.image-item.active .el-image {
    transform: scale(1.05);
}

.image-item.inactive {
    flex-grow: 0.5;
}

.image-item.inactive .el-image {
    transform: scale(0.95);
}

</style>
